import { getQueryFromURL, extractFiltersFromFiltersData, getStartAndEndDate } from "../../../../utils/utility";
import moment from 'moment';
import { canUseDOM } from "../../../utils/canUseDOM";
import { cloneDeep, isEmpty } from 'lodash';
import { removeEmpty } from "../../../../utils/utility";
import queryString from 'query-string';
import { getDictionaryText } from "../../../utils/getDictionaryText";

const checkboxItems = ['location_regions', 'location_titles', 'eventtypes']
const dropdownItems = ['eventcategories', 'period']
const calendarItems = ['startdt_t|enddt_t']

// used to toggle filters (active/deactive)
export const toggleTargetFilters = ({ targets, resetFilters = false, filtersData = [] }) => {
  const resetFiltersHandler = (value) => {
    // Reset selected values for all list items
    value.listItems.forEach(list => {
      list.fields.selected.value = false;
    });

    // Reset calendar values
    if (calendarItems.includes(value.fieldName.value)) {
      value.startDate.value = '';
      value.endDate.value = '';
    }
  };

  const handleCheckboxUpdate = (value, target) => {
    value.listItems.forEach(list => {
      if (list.fields.key.value === target.value) {
        list.fields.selected.value = target.checked ? true : '';
      }
    });
  };

  const handleDropdownUpdate = (value, target) => {
    value.listItems = value.listItems.map(list => {
      const isMatchingKey = value.fieldName.value === 'eventcategories' && target.value.split(',').includes(list.fields.key.value) || list.fields.key.value === target.value;
      return { ...list, fields: { ...list.fields, selected: { ...list.fields.selected, value: isMatchingKey ? (target.checked ? true : '') : '' } } };
    });
  };

  const handleCalendarUpdate = (value, target) => {
    value.startDate.value = target.startDate;
    value.endDate.value = target.endDate;
  };

  return targets.reduce((updatedFilters, target) => {
    return updatedFilters.map(value => {
      const checkName = target.name === value.fieldName.value;
      switch (true) {
        case resetFilters:
          resetFiltersHandler(value);
          break;
        case checkboxItems.includes(target.name) && checkName:
          handleCheckboxUpdate(value, target);
          break;
        case dropdownItems.includes(target.name) && checkName:
          handleDropdownUpdate(value, target);
          break;
        case calendarItems.includes(target.name) && checkName:
          handleCalendarUpdate(value, target);
          break;
      }

      return value;
    });
  }, filtersData);
};

export const splitingNonRemoveableFilters = () => {
  const nonremoveablefilters = getDictionaryText('nonremoveablefilters') || ''
  return new Set(nonremoveablefilters.split(","));
}

export const excludeGTMTags = (filters = []) => {
  const filterSet = splitingNonRemoveableFilters()
  return filters.filter(item => !filterSet.has(item.key));
}

export const isGTMTagsInURL = (obj = {}) => {
  const filterSet = splitingNonRemoveableFilters()
  const objKeys = Object.keys(obj);
  if (objKeys.length === 0) return true;
  const filterKeys = objKeys.filter(key => filterSet.has(key));
  return filterKeys.length > 0 && objKeys.length === filterKeys.length;
}

// get Api Payload
export const getApiPayload = ({ filters = [], filterAdCalendarByDays, params, selectedTab, adEventTabs, dates, startDate, endDate }) => {
  return {
    filters: excludeGTMTags(filters),
    ...(filterAdCalendarByDays?.startDate && { startDate: filterAdCalendarByDays.startDate, endDate: filterAdCalendarByDays.endDate }),
    ...(filterAdCalendarByDays?.calendar?.endDate && { startDate: moment(filterAdCalendarByDays.calendar.startDate, 'MM-DD-YYYY').format('MM-DD-YYYY'), endDate: moment(filterAdCalendarByDays.calendar.endDate, 'MM-DD-YYYY').format('MM-DD-YYYY') }),
    ...(params && { filters: [...filters] }),
    ...(selectedTab !== adEventTabs && dates && { startDate: dates.startDate, endDate: dates.endDate }),
    ...(startDate && endDate && { startDate: moment(startDate, 'MM-DD-YYYY').format('MM-DD-YYYY'), endDate: moment(endDate, 'MM-DD-YYYY').format('MM-DD-YYYY') }),
  };
}

// toggle Feature section for Ad Calendar
export const displayFeatureSection = (select, context = {}) => {
  const element = canUseDOM && document.querySelector('.AdSmartList');
  if (!element) return;
  let shouldHide = false;
  let { filterAdCalendarByDays, adEventTabs, params, filters, selectedTab, filterCount } = context
  filters = excludeGTMTags(filters)
  switch (select) {
    case 'TopBanner': // handleAddCalendarTopBanner
      shouldHide = adEventTabs !== null || params?.value || filterAdCalendarByDays.calendar.endDate || filters?.length > 0;
      break;
    case 'SelectDaysRangeTab': // handleSelectedDays
      shouldHide = (selectedTab !== adEventTabs) || !isEmpty(filterAdCalendarByDays.params?.value) || filters?.length > 0;
      break;
    case 'DatepickerSelection': // handleAdCalendarFilterDatepickerChange
      shouldHide = adEventTabs !== null || !isEmpty(filterAdCalendarByDays.params?.value) || filters?.length > 0;
      break;
    case 'ResetSelectedFilters': // resetAdCalendarSelections
      shouldHide = adEventTabs !== null || !isEmpty(filterAdCalendarByDays.params?.value) || filterAdCalendarByDays.calendar.endDate;
      break;
    case 'toggleDisplayOfSimilarSearchList': // toggleDisplayOfSimilarSearchListAdCalendar
      shouldHide = adEventTabs !== null || !isEmpty(filterAdCalendarByDays.params?.value) || filterAdCalendarByDays.calendar.endDate || filterCount > 0
      break;
    case 'forceHide': // resetAdCalendarSelections
      shouldHide = true
      break;
    case 'forceShow': // resetAdCalendarSelections
      shouldHide = false
      break;
    default:
      return;
  }

  element.style.display = shouldHide ? 'none' : 'flex';
}

export const getDaysPeriod = () => {
  return {
    "fieldLabel": {
      "value": "Date"
    },
    "totalResultCount": 0,
    "fieldName": {
      "value": "period"
    },
    "listItems": [
      {
        "fields": {
          "displayText": {
            "value": "Next Month"
          },
          "key": {
            "value": "next_month"
          },
          "selected": {
            "value": ""
          },
        }
      },
      {
        "fields": {
          "displayText": {
            "value": "This Month"
          },
          "key": {
            "value": "this_month"
          },
          "selected": {
            "value": ""
          },
        }
      },
      {
        "fields": {
          "displayText": {
            "value": "This Week"
          },
          "key": {
            "value": "this_week"
          },
          "selected": {
            "value": ""
          },
        }
      },
    ],
    "selectedValue": {
      "value": ""
    },
    "type": "checkbox"
  }
}

export const eventsCountFormat = (daysCounts = []) => {
  return daysCounts.length > 0 ? daysCounts.reduce((acc, item) => { acc[item.title] = item.count; return acc }, {}) : null
}

// Day Tabs Filter (this_week, this_month, next_month) validation, if data is present in specific tabs which are preselected
export const periodTabFilterValidation = (daysCounts) => {
  if (!daysCounts) return
  const periodValueInUrl = getQueryFromURL('period')
  return { daysEventCounts: (periodValueInUrl && daysCounts[periodValueInUrl] < 1) ? { name: 'period', value: periodValueInUrl, checked: false } : null, daysCounts }
}

export const getDateRangeTabDates = () => {
  const dateRanges = ['this_week', 'this_month', 'next_month'];
  return dateRanges.map((range) => {
    const { startDate, endDate } = getStartAndEndDate(range);
    return { title: range, startDate, endDate };
  });
};

// get selected Filters
export const getSelectedFiltersForPayload = ({ filters = null, filtersData = [] }) => {
  const filtersToAvoid = ['period']
  const selectedFilters = extractFiltersFromFiltersData(filters || filtersData);
  return Object.keys(selectedFilters).filter(o => !filtersToAvoid.includes(o)).flatMap(key =>
    Array.isArray(selectedFilters[key])
      ? selectedFilters[key].map(filter => ({
        key: key,
        value: filter
      }))
      : []
  );
}

// Hide/Remove Feature section
export const toggleDisplayOfFeaturedSection = ({ filters = null, filtersData = [], forceRemove = false, filterAdCalendarByDays, adEventTabs }) => {
  const excludeFilters = splitingNonRemoveableFilters()
  const selectedFilters = extractFiltersFromFiltersData(filters || filtersData);
  const updateSelectedFilters = Object.fromEntries(Object.entries(selectedFilters).filter(([key]) => !excludeFilters.has(key)));
  const filterCount = Object.values(updateSelectedFilters).reduce((sum, arr) => sum + arr.length, 0);
  if (forceRemove) displayFeatureSection('forceShow')
  else displayFeatureSection('toggleDisplayOfSimilarSearchList', { adEventTabs, filterAdCalendarByDays, filterCount })
}

export const handleUpdateQueryParamsForFilter = ({ selectedFilters, isGlobalSearchTemplate, searchTerm }) => {
  let urlQueryParams = cloneDeep(selectedFilters);
  urlQueryParams = removeEmpty(urlQueryParams);
  if (isGlobalSearchTemplate) {
    urlQueryParams.searchTerm = searchTerm;
  }
  const query = queryString.stringify(urlQueryParams, {
    arrayFormat: 'comma',
  });

  if (canUseDOM) {
    window.history.replaceState(
      { turbolinks: {} },
      '',
      `?${query}`
    );
  }
}

export const getUrlQueries = () => {
  return queryString.parse(window && window.location && window.location.search, { arrayFormat: 'comma' });
}